import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { getSubmissionList } from "../../../features/slices/challanges";
import { useSelector } from "react-redux";
import CommonPagination from "../../CommonPagination";

const ListSubmission = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const [page, setPage] = useState(1);
  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };
  useEffect(() => {
    if (state) {
      dispatch(getSubmissionList({ challengeId: state, page }));
    }
  }, [page, state, dispatch]);
  const { submissionList } = useSelector((state) => {
    return state?.challenges;
  });

  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TableList">
            <table className="table-hover">
              <thead>
                <tr>
                  <th>Sr. No</th>
                  <th>Student Id</th>
                  <th>Student Name</th>
                  <th>Submitted On</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {submissionList?.result?.[0]?.paginationData?.map((res, i) => {
                  return (
                    <tr key={res?._id}>
                      <td>{(page - 1) * 10 + i + 1}</td>
                      <td>{res?.studentData?.user_number}</td>
                      <td>{res?.studentData?.fullName}</td>
                      <td>{res?.SubmittedDate}</td>
                      <td>
                        <div className="Actions">
                          <Link
                            to={"/challenges/submissionDetail"}
                            className="Eyes"
                            state={res}
                          >
                            <i className="fa-regular fa-eye" />
                          </Link>
                          <Link
                            to={"/challenges/rankPointAdd"}
                            className="Black"
                            state={res}
                          >
                            Add Rank &amp; Points
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="Pagination">
            <p>
              Showing {(page - 1) * 10 + 1} to{" "}
              {submissionList?.result?.[0]?.paginationData?.length +
                (page - 1) * 10}{" "}
              of {submissionList?.result?.[0]?.totalCount?.[0]?.count} results
            </p>
            <div className="PaginationRight">
              {submissionList?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                <CommonPagination
                  activePage={page}
                  itemsCountPerPage={10}
                  totalItemsCount={
                    submissionList?.result?.[0]?.totalCount?.[0]?.count || 0
                  }
                  pageRangeDisplayed={4}
                  onChange={handlePageChange}
                  itemClass="page-item"
                  linkClass="page-link"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListSubmission;
